import { AlphaGBoxIcon } from './AlphaGBoxIcon';

/**
 * author: GreenTurtwig
 * id A2781290-35AD-441F-B02C-15A0AB49B74D
 * name alpha-g-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-g-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterGBoxIcon = AlphaGBoxIcon;
export default LetterGBoxIcon